module.exports = __webpack_public_path__ + "static/media/right-arrow.1b57b621.svg";